import { cn } from "@/lib/utils";
import { Star } from "lucide-react";

/**
 * Corner star toggle for workspace grid cards (chat, canvas, file record).
 * Render inside a card `preview` slot. Filled amber + always visible when
 * favorited; ghosted and revealed on card hover otherwise. Source of truth for
 * the on-card star treatment across all workspace cards.
 */
export function WorkspaceCardStarButton({
  isFavorite,
  onToggle,
}: {
  isFavorite: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      aria-label={isFavorite ? "Unstar" : "Star"}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      className={cn(
        "absolute left-2 top-2 z-10 flex h-6 w-6 items-center justify-center rounded-full transition-all",
        "bg-background/70 shadow-sm backdrop-blur-sm",
        isFavorite
          ? "text-amber-500 opacity-100"
          : "text-foreground/50 opacity-0 hover:text-amber-500 group-hover:opacity-100",
      )}
    >
      <Star className="h-3 w-3" fill={isFavorite ? "currentColor" : "none"} />
    </button>
  );
}
